var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('ConnectionInform'),(_vm.getHackathonSlide)?_c('iframe',{staticClass:"canvas-iframe",attrs:{"src":`${_vm.getHackathonSlide.canvasUrl}?presentationId=${_vm.presentation.id}&slideId=${_vm.slideActive.id}&isPresenting=${_vm.isPresenting}`,"frameborder":"0"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }